import { generateTrips } from "./types.test.helper"

const mock = [
  {
    finishedAt: `2022-05-05T12:53:00Z`,
    id: `59a2ba78-96a8-44d3-8223-74acf00a948c`,
    startedAt: `2022-05-05T12:45:29Z`,
    analytics: {
      distance: 0.2858,
      riskScore: 67,
    },
  },
  {
    finishedAt: `2022-05-04T12:50:47Z`,
    id: `89338cdc-b112-406a-8a1c-da03124b6379`,
    startedAt: `2022-05-04T11:50:47Z`,
    analytics: {
      distance: 15.1997,
      riskScore: 15,
    },
  },
  {
    finishedAt: `2022-05-05T11:45:01.999Z`,
    id: `00f3349c-bf05-4512-ab2c-1a397f4d040c`,
    startedAt: `2022-05-05T11:43:36.002Z`,
    analytics: {
      distance: 0.7318,
      riskScore: 18,
    },
  },
  {
    finishedAt: `2022-05-05T12:01:04Z`,
    id: `d6185995-c7b4-40d8-8f30-8806a144a911`,
    startedAt: `2022-05-05T11:58:53Z`,
    analytics: {
      distance: 0.9013999999999998,
      riskScore: 90,
    },
  },
  {
    finishedAt: `2022-05-05T10:16:22.017Z`,
    id: `490fce4e-1c6a-495f-a930-3e9e2be98a71`,
    startedAt: `2022-05-05T09:16:22.017Z`,
    analytics: {
      distance: 0.23865081020084372,
      riskScore: 1,
    },
  },
  {
    finishedAt: `2022-05-05T10:54:13Z`,
    id: `028bad63-2e9a-41a7-a55d-35930da37f40`,
    startedAt: `2022-05-05T09:54:13Z`,
    analytics: {
      distance: 5.2577,
      riskScore: 48,
    },
  },
  {
    finishedAt: `2022-05-05T11:06:24Z`,
    id: `2b753526-62d2-43ea-a578-5bef70b900de`,
    startedAt: `2022-05-05T10:06:24Z`,
    analytics: {
      distance: 14.27849494441632,
      riskScore: 74,
    },
  },
  {
    finishedAt: `2022-05-05T10:44:31Z`,
    id: `62eef403-0136-49d7-b6c4-d4fb41ee909e`,
    startedAt: `2022-05-05T09:44:31Z`,
    analytics: {
      distance: 1.6274999999999995,
      riskScore: 99,
    },
  },
  {
    finishedAt: `2022-05-05T10:34:00Z`,
    id: `97855341-9ee6-4659-9fc4-c465c2e50b90`,
    startedAt: `2022-05-05T09:34:00Z`,
    analytics: {
      distance: 0.29419999999999996,
      riskScore: 58,
    },
  },
  {
    finishedAt: `2022-05-05T07:17:04.002Z`,
    id: `1bd17fc4-2c66-4b51-8c09-7d54ffe73656`,
    startedAt: `2022-05-05T06:17:04.002Z`,
    analytics: {
      distance: 0.6076,
      riskScore: 20,
    },
  },
  {
    finishedAt: `2022-05-05T09:31:34Z`,
    id: `b1b8b97a-07b8-4a61-9c66-be7bc684ed21`,
    startedAt: `2022-05-05T08:31:34Z`,
    analytics: {
      distance: 1.4479,
      riskScore: 70,
    },
  },
  {
    finishedAt: `2022-05-05T11:03:55Z`,
    id: `6b6ce5c7-4113-444a-b713-47f282f2a531`,
    startedAt: `2022-05-05T10:03:55Z`,
    analytics: {
      distance: 0.11529999999999999,
      riskScore: 95,
    },
  },
  {
    finishedAt: `2022-05-05T10:40:09Z`,
    id: `f724c6b8-f576-47cd-b79e-4b11fda11c3c`,
    startedAt: `2022-05-05T09:40:09Z`,
    analytics: {
      distance: 13.345199999999995,
      riskScore: 40,
    },
  },
  {
    finishedAt: `2022-04-22T10:41:25.002Z`,
    id: `6742c16f-274d-47c1-956f-6fb9115224dc`,
    startedAt: `2022-04-22T10:40:48.945Z`,
    analytics: {
      distance: 0.1145,
      riskScore: 34,
    },
  },
  {
    finishedAt: `2022-05-05T11:51:15Z`,
    id: `bc3fe38f-ad75-4830-8d5c-3eb8dd097c6b`,
    startedAt: `2022-05-05T08:52:04Z`,
    analytics: {
      distance: 34.3692,
      riskScore: 88,
    },
  },
  {
    finishedAt: `2022-04-29T11:41:13Z`,
    id: `5b8b6acc-e07c-4fb5-9851-3c834cdb9355`,
    startedAt: `2022-04-29T10:41:13Z`,
    analytics: {
      distance: 8.852699999999997,
      riskScore: 7,
    },
  },
  {
    finishedAt: `2022-05-05T09:06:24Z`,
    id: `d56247f1-52b2-4c1e-8a19-b481a21498f0`,
    startedAt: `2022-05-05T08:06:24Z`,
    analytics: {
      distance: 4.3015,
      riskScore: 71,
    },
  },
  {
    finishedAt: `2022-05-05T08:06:50Z`,
    id: `1ee5f2ce-fa30-4a75-b419-b7c5e2e48d61`,
    startedAt: `2022-05-05T07:06:50Z`,
    analytics: {
      distance: 0.3593892095845616,
      riskScore: 45,
    },
  },
  {
    finishedAt: `2022-05-05T10:08:58Z`,
    id: `ca72ec86-d576-4d66-a697-2ff87e59aeb6`,
    startedAt: `2022-05-05T09:08:58Z`,
    analytics: {
      distance: 0.09390000000000001,
      riskScore: 81,
    },
  },
  {
    finishedAt: `2022-05-05T11:02:42Z`,
    id: `05be2c36-cc65-4900-803d-bf47d6461674`,
    startedAt: `2022-05-05T10:02:42Z`,
    analytics: {
      distance: 5.594700000000001,
      riskScore: 59,
    },
  },
  {
    finishedAt: `2022-05-05T10:32:05Z`,
    id: `e35e7728-ccce-472b-9e0c-73971033ee4c`,
    startedAt: `2022-05-05T10:08:04Z`,
    analytics: {
      distance: 3.8758120801803617,
      riskScore: 36,
    },
  },
  {
    finishedAt: `2022-05-05T11:13:55Z`,
    id: `7d356c56-7cc0-478f-8b9a-3efa31a9cb0d`,
    startedAt: `2022-05-05T10:13:55Z`,
    analytics: {
      distance: 3.6659,
      riskScore: 17,
    },
  },
  {
    finishedAt: `2022-05-05T10:37:00Z`,
    id: `619ecf8d-c8e5-4426-9358-f748a864238b`,
    startedAt: `2022-05-05T09:37:00Z`,
    analytics: {
      distance: 0.6029,
      riskScore: 36,
    },
  },
  {
    finishedAt: `2022-05-05T10:46:23Z`,
    id: `6db03639-b18f-4ff0-8ffd-037269a6015b`,
    startedAt: `2022-05-05T09:46:23Z`,
    analytics: {
      distance: 0.24459999999999998,
      riskScore: 20,
    },
  },
  {
    finishedAt: `2022-05-05T10:54:52Z`,
    id: `485a60b3-e49b-40f2-9e61-fbf69d999d56`,
    startedAt: `2022-05-05T08:14:19Z`,
    analytics: {
      distance: 57.14860000000001,
      riskScore: 56,
    },
  },
]

export const tripsDataMock = generateTrips(mock)
